import React from 'react';
import { Box } from '@mui/material';
import LeftCloud from '../assets/images/cloud2.png';
import MiddleCloud from '../assets/images/cloud1.png';
import RightCloud from '../assets/images/cloud.png';
import Plane from '../assets/images/prop_plane.png';
import MyOpinion from '../assets/images/my_opinion_cursive.png';
import SquigglyLine from '../assets/images/my_opinion_squiggle.png';
import { translate } from 'translations/translator';
const t = key => translate('worksheet', key);

const getImageStyles = (): React.CSSProperties => ({
  width: 90,
  height: 65
});

const MyOpinionTitle = ({ displayClouds = true }) => {
  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      {displayClouds && (
        <>
          <img
            src={LeftCloud}
            alt={t('cloud')}
            style={{ ...getImageStyles(), zIndex: 2, margin: '30px 0 0 0' }}
          ></img>
          <img
            src={MiddleCloud}
            className="flippedImage"
            alt={t('cloud')}
            style={{ ...getImageStyles(), margin: '65px 0 0px -60px' }}
          ></img>
        </>
      )}

      <img
        src={MyOpinion}
        alt={displayClouds? t('myOpinionSkyWithClouds') : t('myOpinionSky')}
        style={{ marginTop: displayClouds ? '50px' : '0px', width: 300, height: 65 }}
      ></img>
      <img
        src={SquigglyLine}
        alt=""
        style={{ marginTop: displayClouds ? '81px' : '31px', width: 60, height: 6 }}
      ></img>
      <img
        src={Plane}
        alt={t('plane')}
        style={{
          ...getImageStyles(),
          margin: displayClouds ? '30px 0px 0 -20px' : '-15px 0px 60px -20px',
          zIndex: 2
        }}
      ></img>
      {displayClouds && (
        <img
          src={RightCloud}
          alt={t('cloud')}
          style={{ ...getImageStyles(), margin: '60px -10px 0 -50px' }}
        ></img>
      )}
    </Box>
  );
};

export default MyOpinionTitle;
